import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  padding: ${props => props.$size === 'large' ? '15px 30px' : '10px 20px'};
  background-color: ${props => {
    if (props.$variant === 'primary') return '#D2691E';
    if (props.$variant === 'secondary') return '#FFF8F2';
    if (props.$variant === 'danger') return '#dc3545';
    return '#6B6B6B';
  }};
  color: ${props => props.$variant === 'secondary' ? '#D2691E' : '#ffffff'};
  border: ${props => props.$variant === 'secondary' ? '1px solid #D2691E' : 'none'};
  border-radius: ${props => props.$size === 'large' ? '10px' : '8px'};
  cursor: pointer;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  font-size: ${props => props.$size === 'large' ? '20px' : '16px'};
  transition: all 0.2s;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: ${props => 
      props.$variant === 'primary' ? '0 6px 20px rgba(210, 105, 30, 0.3)' :
      props.$variant === 'secondary' ? '0 4px 12px rgba(210, 105, 30, 0.15)' :
      '0 4px 12px rgba(0, 0, 0, 0.15)'
    };
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    transform: none;
  }
`;

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  disabled = false, 
  onClick, 
  ...props 
}) => {
  return (
    <StyledButton
      $variant={variant}
      $size={size}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
